'use strict';

/**
 * Transition period override states.
 * Tracks the state of a transition period override.
 */
module.exports = {
  pending: 'pending', // The transition period override has been created and will become active in the next workpackage.
  active: 'active', // The transition period override is active.
  expiring: 'expiring', // The transition period override is no longer active as the workpackage's go-live date is past the expiry date.
  overridden: 'overridden', // The transition period override has been overidden by another type of override.
};
